import { DIRECTION_CONFIG } from '../../modules/huntingWordsGenerator/components/HuntingWordsModel';

export function renderHighlightRect(h, config) {
  const dir = DIRECTION_CONFIG[h.direction];
  if (!dir) return '';

  const { cellSize } = config;

  const width = dir.getWidth(cellSize, h.length);
  const height = dir.getHeight(cellSize, h.length);

  const isUpLeft = h.direction === 'up-left';
  const isUpRight = h.direction === 'up-right';
  const shouldAdjustCol = dir.adjustCol && !isUpLeft && !isUpRight;

  const adjustedCol = shouldAdjustCol ? h.col + 1 : h.col;
  const adjustedRow = isUpLeft ? h.row + 1 : h.row;

  const cx = (adjustedCol * cellSize) + dir.adjustPrintX;
  const cy = (adjustedRow * cellSize) + dir.adjustPrintY;

  const transform = dir.transformAngle !== null
    ? `rotate(${dir.transformAngle}, ${cx}, ${cy})`
    : '';

  return `<rect
    x="${cx}"
    y="${cy}"
    width="${width}"
    height="${height}"
    fill="none"
    stroke="${config.highlightStroke || '#000'}"
    stroke-width="${config.highlightStrokeWidth || 2}"
    rx="10"
    ry="10"
    ${transform ? `transform="${transform}"` : ''}
  />`;
}

function generateHuntingWordsSVG(grid, rows, cols, options = {}) {
  const defaults = {
    cellSize: 33,
    fontSize: 24,
    padding: 20,
    fontFamily: 'Arial, sans-serif',
    textColor: '#212529',
    borderColor: 'rgba(0, 0, 0, 0.1)',
    borderWidth: 1,
    showCellBorders: false,
    showCellBackground: true,
    cellBackgroundColor: '#ffffff',
    highlightedWords: [],
    highlightStroke: '#000',
    highlightStrokeWidth: 2,
    // Hunting words stores positionx=row / positiony=col; SVG uses x/y.
    swapAxes: true,
    hideEmptyCells: false,
  };

  const config = { ...defaults, ...options };

  const svgWidth = cols * config.cellSize + config.padding * 2;
  const svgHeight = rows * config.cellSize + config.padding * 2;

  const fixedTable = config.swapAxes
    ? grid.map(cell => ({
      ...cell,
      positionx: cell.positiony,
      positiony: cell.positionx,
    }))
    : grid;

  let svg = `
  <svg xmlns="http://www.w3.org/2000/svg" width="${svgWidth}" height="${svgHeight}" viewBox="0 0 ${svgWidth} ${svgHeight}">
    <style>
      .cell {
        font-family: ${config.fontFamily};
        font-size: ${config.fontSize}px;
        text-anchor: middle;
        fill: ${config.textColor};
        text-shadow: 0 0 0.4px currentColor;
        font-weight: 400;
      }
    </style>
    <g transform="translate(${config.padding}, ${config.padding})">
  `;

  // eslint-disable-next-line no-restricted-syntax
  for (const cell of fixedTable) {
    // null/undefined = black/empty cell; '' = playable cell without letter (enigma)
    const isNullCell = cell.text == null;
    const cellText = isNullCell ? '' : String(cell.text);
    const hasText = cellText.trim().length > 0;

    if (config.hideEmptyCells && isNullCell) {
      // eslint-disable-next-line no-continue
      continue;
    }

    const x = Number(cell.positionx) * config.cellSize;
    const y = Number(cell.positiony) * config.cellSize;

    if (config.showCellBackground || config.showCellBorders) {
      const fill = config.showCellBackground ? config.cellBackgroundColor : 'none';
      const stroke = config.showCellBorders ? config.borderColor : 'none';
      const strokeWidth = config.showCellBorders ? config.borderWidth : 0;

      svg += `<rect
        x="${x}"
        y="${y}"
        width="${config.cellSize}"
        height="${config.cellSize}"
        fill="${fill}"
        stroke="${stroke}"
        stroke-width="${strokeWidth}"
      />`;
    }

    if (hasText) {
      svg += `<text
        x="${x + config.cellSize / 2}"
        y="${y + config.cellSize / 2}"
        dy=".35em"
        class="cell"
      >${cellText}</text>`;
    }
  }

  // eslint-disable-next-line no-restricted-syntax
  for (const h of config.highlightedWords) {
    svg += renderHighlightRect(h, config);
  }

  svg += '</g></svg>';
  return svg;
}


export default generateHuntingWordsSVG;
